<script lang="ts">
  import NewAddress from "../Address/NewAddress.svelte";
  import Address from "../Address/Address.svelte";
  import { onMount } from "svelte";
  import { getAddresses } from "../../lib/helpers/userManager";
  import { addressesStore } from "../../lib/stores/addresses";
  import BaseStep from "./BaseStep.svelte";
  import LoadingScreen from "../LoadingScreen.svelte";
  import { resetCampaignUserPhase } from "../../lib/helpers/steps/review";

  export let currentRoute;

  let isLoading = true;

  onMount(async () => {
    isLoading = true;
    // FIXME: we force a phase-reset here to make sure that, if the user lands here on any way, the phase is reset
    // but a better approack would be to actually check if there are address changes on Next and reset if so
    await Promise.all([ resetCampaignUserPhase(), getAddresses() ]);
    isLoading = false;
  });
</script>

{#if isLoading}
  <BaseStep {currentRoute}>
    <svelte:fragment slot="content">
      <LoadingScreen />
    </svelte:fragment>
  </BaseStep>
{:else if $addressesStore.mode === "create"}
  <NewAddress {currentRoute} />
{:else}
  <Address {currentRoute} />
{/if}
